module.exports = __webpack_public_path__ + "img/-e-person_bg@2x.511354ac.png";